export default "__VITE_ASSET__B2S5LZqr__"